<div class="row g-1 mb-2">
    <div class="col-md-4">
        <div class="card h-100 m-0">
            <div class="card-body p-1">
                <div class="row">
                    <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;text-align: -webkit-center;">Online
                        Attendance</label>
                </div>
                <div class="row">
                    <label class="form-label"
                        style="font-size: 25px!important;font-weight: 500; margin-bottom: 5px;text-align: -webkit-center;">{{Duration}}</label>
                </div>
                <div style="background-color:#80808036;border-radius: 5px;" class="p-2 mb-2">
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Branch</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.BranchName}}</label>
                        </div>
                    </div>
                    <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Site</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.SiteName}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.DesignationName}}</label>
                        </div>
                    </div>
                    <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Duty</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.DutyName}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Shift</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.ShiftTitle}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">In
                                Date Time</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.InTime??''
                                | date: 'dd-MMM-yyyy H:mm:ss'}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Out
                                Date Time</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.OutTime??''
                                | date: 'dd-MMM-yyyy H:mm:ss'}}</label>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                                        <div class="col-md-12 d-grid" *ngIf="!isDisabled">
                                            <button class="btn btn-primary"
                                                *ngIf="isShowAttendaceBtn && !AttendanceDetail.IsCheckIn && !AttendanceDetail.IsAttendaceClose"
                                                mat-raised-button color="primary" type="button"
                                                (click)="GetDateTime(true)"
                                                [disabled]="AttendanceDetail.IsAttendaceClose || isDisabled"><i
                                                    class="bi bi-box-arrow-in-right me-2"></i>Check
                                                In</button>
                                            <button class="btn btn-danger"
                                                *ngIf="isShowAttendaceBtn && AttendanceDetail.IsCheckIn && !AttendanceDetail.IsAttendaceClose"
                                                mat-raised-button color="warn" type="button" (click)="GetDateTime(true)"
                                                [disabled]="AttendanceDetail.IsAttendaceClose || isDisabled"><i
                                                    class="bi bi-box-arrow-in-left me-2"></i>Check Out</button>
                                        </div>
                                    </div> -->
            </div>
        </div>
    </div>

    <div class="col-md-8">
        <div class="card h-100 m-0">
            <div class="card-body p-1">
                <div class="row" style="place-content:center">
                    <div class="col-auto">
                        <ngb-datepicker #dp [(ngModel)]="filter.AttendanceDate" (navigate)="onNavigate($event)"
                            [dayTemplate]="customDay" (dateSelect)="CalenderDateSelect($event)"></ngb-datepicker>
                        <ng-template #customDay ngbdatepickerdayview let-date="date" let-currentMonth="currentMonth"
                            let-selected="selected" let-disabled="disabled">
                            <div class="day-container" style="text-align: center;
                width: 2rem;
                height: 2rem;
                line-height: 2rem;
                border-radius: .25rem;
                background: transparent;">
                                <span class="custom-day" [class.faded]="date.month !== currentMonth"
                                    [class.selected]="selected" [class.disabled]="disabled"
                                    [ngStyle]="getDayStyle(date)">
                                    {{ date.day }}
                                </span>
                                <div class="dot" [ngStyle]="getDayDotStyle(date)"></div>
                                <div class="dot2" [ngStyle]="getDayDotStyle2(date)"></div>
                                <!-- New dot element -->
                            </div>
                        </ng-template>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-3">
                                        <img *ngIf="CalendarDetailsData.Photo != null && CalendarDetailsData.Photo != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(CalendarDetailsData.Photo)" />
                                        <div *ngIf="CalendarDetailsData.Photo == null || CalendarDetailsData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{CalendarDetailsData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{CalendarDetailsData.EmpCode}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{CalendarDetailsData.DesignationName}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-md-4">
                                <label for="RequestDate" class="text-label-light">Attendance
                                    Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{CalendarDetailsData.AttendanceDate!=
                                    null?this.dateFormat.format(CalendarDetailsData.AttendanceDate):''}}</label>
                            </div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-1 mb-2">
                            <div class="row align-items-center">
                                <div class="col-md-5">
                                    <div class="row align-items-center">
                                        <div class="col-3">
                                            <img *ngIf="CalendarDetailsData.DailyAttendancePhoto != null && CalendarDetailsData.DailyAttendancePhoto != ''"
                                                mat-card-image class="userImage"
                                                [src]="CalendarDetailsData.DailyAttendancePhoto"
                                                (click)="common.FullImage(CalendarDetailsData.DailyAttendancePhoto,{ProfileImage:common.PhotoLink(CalendarDetailsData.Photo),Name:CalendarDetailsData.EmployeeName,Code:CalendarDetailsData.EmpCode??'',Designation:CalendarDetailsData.DesignationName??''} )" />
                                            <div *ngIf="CalendarDetailsData.DailyAttendancePhoto == null || CalendarDetailsData.DailyAttendancePhoto == ''"
                                                class="initial-image">
                                                <div class="image">
                                                    {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <label for="InTime" class="text-label-light">In
                                                Time</label> <br />
                                            <label name="InTime" style="font-size: 0.8rem;" class="text-label-dark"
                                                *ngIf="CalendarDetailsData.InTime != null">{{CalendarDetailsData.InTime
                                                | date : 'dd MMM yyyy'}}</label>
                                            <br />
                                            <label name="InTime" style="font-size: 0.8rem;" class="text-label-dark"
                                                *ngIf="CalendarDetailsData.InTime != null">{{CalendarDetailsData.InTime
                                                | date : 'HH:mm:ss'}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="row align-items-center">
                                        <div class="col-3">
                                            <img *ngIf="CalendarDetailsData.DailyAttendancePhotoOut != null && CalendarDetailsData.DailyAttendancePhotoOut != ''"
                                                mat-card-image class="userImage"
                                                [src]="CalendarDetailsData.DailyAttendancePhotoOut"
                                                (click)="common.FullImage(CalendarDetailsData.DailyAttendancePhotoOut,{ProfileImage:common.PhotoLink(CalendarDetailsData.Photo),Name:CalendarDetailsData.EmployeeName,Code:CalendarDetailsData.EmpCode??'',Designation:CalendarDetailsData.DesignationName??''} )" />
                                            <div *ngIf="CalendarDetailsData.DailyAttendancePhotoOut == null || CalendarDetailsData.DailyAttendancePhotoOut == ''"
                                                class="initial-image">
                                                <div class="image">
                                                    {{common.getInitial(CalendarDetailsData.EmployeeName)}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <label for="OutTime" class="text-label-light">Out
                                                Time</label> <br />
                                            <label name="OutTime" style="font-size: 0.8rem;" class="text-label-dark"
                                                *ngIf="CalendarDetailsData.OutTime != null">{{CalendarDetailsData.OutTime
                                                | date : 'dd MMM yyyy'}}</label>
                                            <br />
                                            <label name="OutTime" style="font-size: 0.8rem;" class="text-label-dark"
                                                *ngIf="CalendarDetailsData.OutTime != null">{{CalendarDetailsData.OutTime
                                                | date :
                                                'HH:mm:ss'}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div *ngIf="calculateTotalDuration(CalendarDetailsData.InTime | date : 'HH:mm:ss', CalendarDetailsData.OutTime | date : 'HH:mm:ss') !== ''"
                                        style="background: linear-gradient(to right, #338AF3, #4B65DF); color: white; border-radius: 10px;">
                                        <p class="pt-1"
                                            style="font-size: 0.7rem; font-weight: bold; text-align: center; margin: auto">
                                            {{calculateTotalDuration(CalendarDetailsData.InTime |
                                            date : 'HH:mm:ss',
                                            CalendarDetailsData.OutTime | date : 'HH:mm:ss') }}
                                        </p>
                                        <p class="p-1" style="font-size: 0.7rem; text-align: center; margin: auto;">
                                            Total Hour</p>
                                    </div>
                                </div>
                                <div class="col-md-12"
                                    *ngIf="CalendarDetailsData.InTime == null && CalendarDetailsData.OutTime == null"
                                    style="text-align: -webkit-center">
                                    <label class="text-label-light" style="font-weight: 500;">Attendance Not
                                        Punch</label>
                                </div>
                            </div>
                        </div>

                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <!-- <div class="row">
                                                    <div class="col-4">
                                                        <label class="form-label"
                                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
                                                    </div>
                                                    <div class="col">
                                                        <label class="form-label"
                                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.DesignationName}}</label>
                                                    </div>
                                                </div> -->
                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Shift</label>
                                </div>
                                <div class="col">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.ShiftTitle}}</label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">In
                                        Reason</label>
                                </div>
                                <div class="col">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.InReason}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Out
                                        Reason</label>
                                </div>
                                <div class="col">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.OutReason}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Type</label>
                                </div>
                                <div class="col">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.AttendanceDescription}}</label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-4">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Remark</label>
                                </div>
                                <div class="col">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{CalendarDetailsData.Remark}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-auto" *ngFor="let cDSummary of calendarDataSummary;let i=index">
                        <span class="badge success"
                            [ngStyle]="{'background-color': cDSummary.Colour}">{{cDSummary.Type}}
                            ({{cDSummary.Count}})</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>